import React, {Fragment} from 'react';

const SpotsSection = ({totalSpots, enforceReservationLimit}) => {
    if (!enforceReservationLimit) {
        return null;
    }

    return (
        <Fragment>
            <div>
                <div className="field-label heavy">{'Total Spots'}</div>
                <span id="available-spots">{totalSpots}</span>
            </div>
        </Fragment>
    );
};

export default SpotsSection;



// WEBPACK FOOTER //
// ./src/event/SpotsSection.js